import PropTypes from 'prop-types'
import cn from '../modules/cn'

function Checkbox({
  checked,
  label,
  onChange,
  name,
  className,
  ...props
}) {
  return (
    <div className="flex items-center mb-2">
      <input
        type="checkbox"
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...props}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        name={name}
        id={name}
        className={cn(
          'peer w-[1.125em] h-[1.125em] border-2 border-gray-200',
          'text-theme-500 rounded focus:ring-theme-500 focus:ring-offset-1 focus:ring-1',
          'enabled:hover:text-theme-600 enabled:hover:border-gray-300 cursor-pointer',
          'disabled:cursor-not-allowed disabled:bg-gray-50 disabled:border-gray-100',
          'checked:text-theme-500 checked:hover:border-none checked:disabled:bg-gray-100',
          className,
        )}
      />
      {label && (
        <label
          className={cn(
            'text-gray-900 pl-2',
            'peer-disabled:text-gray-400 peer-disabled:pointer-events-none',
          )}
          htmlFor={name}
        >
          {label}
        </label>
      )}
    </div>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: cn.propType,

}

Checkbox.defaultProps = {
  checked: false,
  name: null,
  label: null,
  onChange: () => {},
  className: null,
}

export default Checkbox
